import { Injectable } from '@angular/core';

import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

/** Service auxiliar para utilizar o recurso de drag-drop do component Angular CDK Drad an Drop
 * https://material.angular.io/cdk/drag-drop/overview
 */
@Injectable({
    providedIn: 'root'
})
export class DragDropService {

    /** Verifica se o evento de drop foi realizado dentro da mesma lista */
    isSameDropList<T>(event: CdkDragDrop<T[]>): boolean {
        if (!event) {
            return;
        }

        return event.previousContainer === event.container;
    }

    /** Realiza o evento de drop do item informado */
    drop<T>(event: CdkDragDrop<T[]>) {
        if (!event) {
            return;
        }

        if (this.isSameDropList(event)) { // Se o drop for realizado na mesma listagem em que o item já sem encontra, somente move o item para o novo index em que ele foi alterado
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else { // Se não, trasnfere o item para a nova lista
            transferArrayItem(event.previousContainer.data,
                            event.container.data,
                            event.previousIndex,
                            event.currentIndex);
        }
    }

    /** Cancela o evento do drop informado retornando o item para a sua posição e/ou lista anterior */
    dropCancel<T>(event: CdkDragDrop<T[]>) {
        if (!event) {
            return;
        }

        if (event.container === event.previousContainer) {
            moveItemInArray(event.previousContainer.data, event.currentIndex, event.previousIndex);
        } else {
            transferArrayItem(event.container.data,
                            event.previousContainer.data,
                            event.currentIndex,
                            event.previousIndex);
        }
    }

}
